module.exports = __webpack_public_path__ + "img/img45.20894877.svg";